import { WINGMATE_API_URL } from '@hcs/urls';
export const WINGMATE_API_WS_URL = `${WINGMATE_API_URL}/askws`;
export const CANARYAI_DEV_TOOLS_ENABLED = 'canaryai-dev-tools-enabled';
